import React from 'react';
import styled from 'styled-components';
import redepagosIcon from './redepagos.png';
import { SectionHeader } from '../../../../components/SectionHeader';
import { CircularArrowButton } from '../CircularArrow/CircularArrowButton';
import { styles } from '../../../../styles';
import { Nullable } from '@eroman/common/src/_base/lang/Nullable';
import { BarcodeStates } from '@eroman/common/src/views/app/Expenses/ExpensesVM';

export const Redepagos: React.FC<Props> = (props) => {
    if (props.useBarcode) {
        return <>
            <Header>
                <SectionHeader icon={redepagosIcon} title='Pagar con REDEPAGOS' color='#119611' />
            </Header>
            <BarcodeContent aria-busy={props.barcodeState === BarcodeStates.Loading}>
                <BarcodeDescription>Código de barras de Redepagos</BarcodeDescription>
                <div role="status" aria-live="polite">
                    {props.barcodeState === BarcodeStates.Loading && <Message>Cargando código de barras…</Message>}
                    {props.barcodeState === BarcodeStates.NotFound && <Message>Todavía no hay un código de barras disponible para esta expensa.</Message>}
                    {props.barcodeState === BarcodeStates.Error && <Message>No pudimos obtener el código.</Message>}
                </div>
                {props.barcodeState === BarcodeStates.Ready && props.image && <BarcodeImage
                    src={`data:image/png;base64,${props.image}`}
                    alt="Código de barras de Redepagos"
                    onError={() => props.onImageError(props.image!)}
                />}
                {(props.barcodeState === BarcodeStates.Error || props.barcodeState === BarcodeStates.NotFound) &&
                    <RetryButton type="button" onClick={props.onRetry}>Reintentar</RetryButton>}
            </BarcodeContent>
        </>;
    }
    return (
        <>
            <Header>
                <SectionHeader icon={redepagosIcon} title='Pagar con REDEPAGOS' color='#119611' />
                {(props.url != null) ?
                    <CircularArrowButton color="#119611" href={props.url} target="_blank" /> :
                    <CircularArrowButton color="#119611" isDisabled={true}/>
                }
            </Header>
            <Description>
                Mercadopago, Pagofacil, Rapipago, Pagomiscuentas, Redlink o D&eacute;bito directo. F&aacute;cil y seguro.
                <span> Recibo electr&oacute;nico autom&aacute;tico.</span>
            </Description>
        </>
    );
};

const Header = styled.div`
  display: flex;
  margin: 20px 20px 0;
  align-items: center;
  justify-content: space-between;
`;

const Description = styled.p`
  margin: 0 60px;
  font-size: ${styles.fonts.size.regular};
  font-weight: ${styles.fonts.weight.regular};
  
  span {
    font-weight: 400;
  }
`;

const BarcodeContent = styled.div`
  margin: 12px 20px 24px;
  color: ${styles.textColor};
  font-size: ${styles.fonts.size.regular};
`;

const BarcodeDescription = styled.p`
  margin: 0 0 16px;
`;

const Message = styled.p`
  margin: 0 0 16px;
`;

const BarcodeImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  background: #FFFFFF;
`;

const RetryButton = styled.button`
  padding: 8px 16px;
  border: 1px solid #117511;
  border-radius: 8px;
  background: #FFFFFF;
  color: #117511;
  font: inherit;
  cursor: pointer;

  &:hover { background: #F1F8F1; }
  &:focus-visible { outline: 2px solid ${styles.focusedColor}; outline-offset: 3px; }
`;

interface Props {
    url: Nullable<string>;
    useBarcode: boolean;
    barcodeState: BarcodeStates;
    image: Nullable<string>;
    onRetry: () => void;
    onImageError: (image: string) => void;
}
